import {ElementInterface} from './ElementInterface';

export class BBElement implements ElementInterface {

    target: HTMLElement;

    public constructor(target: HTMLElement) {
        this.target = target;
    }

    public hasClass(className: string): boolean {
        return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.target.className);
    }

    public addClass(className: string): boolean {
        if (this.target.classList) {
            this.target.classList.add(className);
        } else if (!this.hasClass(className)) {
            this.target.setAttribute('class', this.target.getAttribute('class') + ' ' + className);
        }
        return true;
    }

    public removeClass(className: string): boolean {
        if (this.target.classList) {
            this.target.classList.remove(className);
        } else if (this.hasClass(className)) {
            this.target.setAttribute('class', this.target.getAttribute('class').replace(className, ' '));
        }
        return true;
    }

    public remove(): boolean {
        this.target.parentElement.removeChild(this.target);
        return true;
    }

}